import variables from "./variables";
import {notify} from "./features/functions";
import i18next from "i18next";

class Mission {
    constructor(key="", name="", description="", conditions="", props={}) {
        this.key = key;
        this.name = name;
        this.description = description;
        this.conditions = conditions;
        this.tasks = {};
        this.nextKey = props.nextKey;
        this.isInit = props.isInit;
        this.isLast = props.isLast;
        this.started = variables.missions[key] ? variables.missions[key].started : false;
        this.finished = variables.missions[key] ? variables.missions[key].finished : false;
    };

    addTasks(tasks={}) {
        this.tasks = tasks;
    }

    start() {
        this.started = true;
        if (this.tasks && Object.keys(this.tasks).length > 0) {
            let initTask = null;
            Object.keys(this.tasks).forEach(taskName => {
                if (this.tasks[taskName].isInit) initTask = this.tasks[taskName];
            })
            initTask.started = true;
            variables.missions.addNew(initTask.key, {started: true});
        }
        variables.missions.addNew(this.key, {started: true});
        notify(<span><span style={{color: "orange"}}>New Mission</span> <b>{i18next.t(this.name)}</b> was started. You can check it in the left side menu -> Photo -> Information</span>)
    };

    isActive() {
        return this.started && !this.finished;
    };

    finish() {
        this.finished = true;
        variables.missions[this.key].finished = true;
        notify(`Mission ${i18next.t(this.name)} was finished`)
    };

    finishCurrentTask(startNext = true) {
        for (const [key, task] of Object.entries(this.tasks)) {
            if (task.started && !task.finished) {
                task.finish();
                if (task.isLast)
                    return this.finish();
                if (startNext && task.nextKey)
                    return this.tasks[task.nextKey].start();
            }
        }
    };
}

const initCorruption_01 = new Mission(
    "initCorruption_01",
    "other.missions.initCorruption_01.name",
    "other.missions.initCorruption_01.description"
);
initCorruption_01.addTasks({
    checkInstruction_01: new Mission(
        "checkInstruction_01",
        "other.missions.checkInstruction_01.name",
        "other.missions.checkInstruction_01.description",
        "",
        {nextKey: "getInfoAboutDrink_01", isInit: true}
    ),
    getInfoAboutDrink_01: new Mission(
        "getInfoAboutDrink_01",
        "other.missions.getInfoAboutDrink_01.name",
        "other.missions.getInfoAboutDrink_01.description",
        "other.missions.getInfoAboutDrink_01.conditions",
        {nextKey: "buyADrink_01"}
    ),
    buyADrink_01: new Mission(
        "buyADrink_01",
        "other.missions.buyADrink_01.name",
        "other.missions.buyADrink_01.description",
        "other.missions.buyADrink_01.conditions",
        {nextKey: "treatWifePill_01"}
    ),
    treatWifePill_01: new Mission(
        "treatWifePill_01",
        "other.missions.treatWifePill_01.name",
        "other.missions.treatWifePill_01.description",
        "other.missions.treatWifePill_01.conditions",
        {nextKey: "checkChanges_01"}
    ),
    checkChanges_01: new Mission(
        "checkChanges_01",
        "other.missions.checkChanges_01.name",
        "other.missions.checkChanges_01.description",
        "other.missions.checkChanges_01.conditions",
        {nextKey: "askAtOfficeAboutWife_01"}
    ),
    askAtOfficeAboutWife_01: new Mission(
        "askAtOfficeAboutWife_01",
        "other.missions.askAtOfficeAboutWife_01.name",
        "other.missions.askAtOfficeAboutWife_01.description",
        "other.missions.askAtOfficeAboutWife_01.conditions",
        {nextKey: "tellWifeAboutJobOps_01"}
    ),
    tellWifeAboutJobOps_01: new Mission(
        "tellWifeAboutJobOps_01",
        "other.missions.tellWifeAboutJobOps_01.name",
        "other.missions.tellWifeAboutJobOps_01.description",
        "",
        {nextKey: "goToInterviewAsWife_01"}
    ),
    goToInterviewAsWife_01: new Mission(
        "goToInterviewAsWife_01",
        "other.missions.goToInterviewAsWife_01.name",
        "other.missions.goToInterviewAsWife_01.description",
        "other.missions.goToInterviewAsWife_01.conditions",
        {nextKey: "goHome_01"}
    ),
    goHome_01: new Mission(
        "goHome_01",
        "other.missions.goHome_01.name",
        "other.missions.goHome_01.description",
        "",
        {isLast: true}
    )
});

const missions = {
    initCorruption_01
};

export default missions;